import type React from 'react';

function ElgigantenIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 424 424"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Elgiganten Icon</title>
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="102.57"
          y1="305.7"
          x2="257.22"
          y2="153.04"
          gradientTransform="translate(0 82.39)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".28" stop-color="#9fc755" />
          <stop offset=".29" stop-color="#9bc354" />
          <stop offset=".53" stop-color="#629550" />
          <stop offset=".74" stop-color="#387d4d" />
          <stop offset=".9" stop-color="#30704b" />
          <stop offset="1" stop-color="#2e6c4a" />
        </linearGradient>

        <linearGradient
          id="linear-gradient-2"
          x1="108.35"
          y1="-39.92"
          x2="324.46"
          y2="170.24"
          gradientTransform="translate(0 82.39)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#2e6c4a" />
          <stop offset=".11" stop-color="#2f6e4a" />
          <stop offset=".23" stop-color="#33764c" />
          <stop offset=".38" stop-color="#43824e" />
          <stop offset=".52" stop-color="#669750" />
          <stop offset=".68" stop-color="#90b952" />
          <stop offset=".72" stop-color="#9fc755" />
        </linearGradient>
      </defs>

      <g id="Layer_1-2" data-name="Layer 1">
        <rect x="0" y="0" width="424" height="424" fill="none" />

        <path
          id="path179"
          d="M213.72,239.06l-47.71,50.69c-28.82,28.82-33.79,65.84-33.79,80.01-.25,1.49-.25,2.73-.25,4.47v.5c0,12.17,2.73,27.83,4.47,32.05l3.48,11.18,100.88-102.62c14.16-14.16,21.12-33.79,19.38-53.92-1.49-15.4-8.45-30.06-19.38-41l-12.42-12.42-5.47-5.47c0,.5,4.97,19.38-9.19,36.52"
          fill="url(#linear-gradient)"
        />

        <path
          id="path196"
          d="M136.45,16.68c0,.5-7.95,29.82,2.48,66.34,8.45,29.32,32.3,56.4,32.3,56.4l99.64,99.88c16.9,16.9,12.17,38.02,11.68,38.76h0l4.47-4.97,12.92-12.42c11.18-11.18,17.89-25.59,19.38-41,.25-2.24,.5-4.22,.5-6.21v-.5c0-17.64-7.21-34.54-19.63-47.21L138.93,6l-2.48,10.68Z"
          fill="url(#linear-gradient-2)"
        />
      </g>
    </svg>
  );
}

export default ElgigantenIcon;
